
/* global require, jQuery, selfAddressed */

(function (factory) {
    if (typeof require == 'function') {
        require('script!../node_modules/jquery/dist/jquery.min.js');
        require('script!../node_modules/self-addressed/dist/self-addressed.js');
    }

    factory(window, document, jQuery.noConflict(true), selfAddressed);
} (function (window, document, $, selfAddressed) {
    "use strict";

    var hostlib = {},
        externalLoginEvent = [],
        externalLogoutEvent = [];

    function log(msg){
        if (!window.console || !window.console.log){
            return;
        }

        console.log(["*** hostlib.js", msg].join(" - "));
    }

    hostlib.injectContest = function (contestTag) {
        log("injectContest()");

        // Find contest tag and replace with iframe
        // Allow bootstrap or auto-load
        if (!contestTag) {
            contestTag = document.getElementsByTagName("contest")[0];
        }

        if (!contestTag || contestTag.length === 0) {
            throw new Error("Unable to bootstrap contest due to missing <contest></contest> tag!");
        }

        var contestId,
            contestOrigin,
            contestIframe,
            scrollDiv,
            orgId,
            parentContestId,
            firstResizeFlag = true;

        var contestHeight = 700;
        var contestWidth = 800;
        var contestSrc = "";
        var apiUrl = "";
        var accessToken = "";
        var sfott = "";

        var widgetConfig = contestTag.getAttribute('config');
        if (!widgetConfig) {

            contestId = contestTag.dataset.contestid;
            contestOrigin = contestTag.dataset.contestorigin;
            apiUrl = contestTag.dataset.apiurl;
            accessToken = contestTag.dataset.accesstoken;
            if (contestTag.dataset.orgid) {
                orgId = contestTag.dataset.orgid;
            }
            if (contestTag.dataset.contestHeight) {
                contestHeight = contestTag.dataset.contestHeight;
            }
            if (contestTag.dataset.contestWidth) {
                contestWidth = contestTag.dataset.contestWidth;
            }
            sfott = contestTag.dataset.sfott;
        } else {
            // TODO: Do we need the custom base64decode here?
            var config = JSON.parse(window.atob(widgetConfig));

            // console.dir(config);

            contestId = config.contestId;

            // TODO: Validate contestOrigin as url
            contestOrigin = config.contestOrigin;

            // Have tags override config values for height and width
            if (contestTag.getAttribute('height')) {
                contestHeight = contestTag.getAttribute('height');
            } else if (config.contestHeight) {
                contestHeight = config.contestHeight;
            }

            if (contestTag.getAttribute('width')) {
                contestWidth = contestTag.getAttribute('width');
            } else if (config.contestWidth) {
                contestWidth = config.contestWidth;
            }

            apiUrl = config.apiUrl;
            accessToken = config.accessToken;

            if (config.orgId) {
                orgId = config.orgId;
            }

            sfott = config.sfott;
        }

        // For rewards, put a bad token if it doesn't exist to ensure a logout
        //engagement site will always put "xxxx" or a valid token there
        if (sfott === "xxxxxxxxxxxxxxx") {
            sfott = "logout";
        }

        // Use api to get contest type
        var contestType = "";
        if (apiUrl && accessToken) {
            var params = { "accessToken": accessToken };
            // If orgId is present, assume that we need a syndicated contestId
            if (orgId) {
                parentContestId = contestId;
                $.ajax({
                    url: modifyUrl(apiUrl, "contests/" + parentContestId + "/syndications/" + orgId, null),
                    method: "GET",
                    data: params
                }).then(function (response) {
                    contestType = response.data.contestType;

                    var micrositeUrl = response.data.micrositeUrl;
                    if (micrositeUrl.lastIndexOf('/') === micrositeUrl.length - 1) {
                        micrositeUrl = micrositeUrl.slice(0, micrositeUrl.length - 2);
                    }
                    var idMatches = micrositeUrl.match(/(?:.(?!......))+$/g);
                    if (idMatches) {
                        contestId = idMatches[0];
                    }

                    contestSrc = getContestSrc();
                    loadContest();
                }, function (error) {
                    contestSrc = getContestSrc();
                    loadContest();
                });
            } else {
                $.ajax({
                    url: modifyUrl(apiUrl, "contests/" + contestId, null),
                    method: "GET",
                    data: params
                }).then(function (response) {
                    contestType = response.data.contestType;
                    contestSrc = getContestSrc();
                    loadContest();
                }, function (error) {
                    contestSrc = getContestSrc();
                    loadContest();
                });
            }
        } else {
            contestSrc = getContestSrc();
            loadContest();
        }

        function getContestSrc() {
            var src = modifyUrl(contestOrigin, contestId);
            var path = getQueryVariable(window.location, "tdpath");

            if (sfott) {
                // Only login if we aren't logged in already
                if ((sfott === "logout") || (!getCookie("ENT") || !getCookie("tl_ugc"))) {
                    var page = "";
                    switch (contestType) {
                        case 3: // Brackets
                            page = "Account/Logon";
                            break;
                        case 2: // Sweepstakes
                            page = "Sweepstakes/Landing";
                            break;
                        case 1: // UGC
                            page = "Account/Logon";
                            break;
                    }
                    src = modifyUrl(src, page, null);
                } else {
                    // Deep linking
                    // look for path query variable, append to origin
                    if (path) {
                        src = modifyUrl(contestOrigin, decodeURIComponent(path));
                    }
                }
                src = modifyUrl(src, null, ["sfott=" + sfott]);
                // Check referral token
                if (path) {
                    var loc = getLocation(modifyUrl(contestOrigin, decodeURIComponent(path)));
                    var rft = getQueryVariable(loc, "rft");
                    src = modifyUrl(src, null, ["rft=" + rft]);
                }
            } else {
                // Deep linking
                // look for path query variable, append to origin
                if (path) {
                    src = modifyUrl(contestOrigin, decodeURIComponent(path));
                }
            }

            return src;
        }

        // TODO: api service for config overrides?

        function setProperUrlProtocol(url){
            //remove https:// or http:// from url
            if (url.indexOf("https:") === 0){
                url = url.substr("https://".length);
            } else if (url.indexOf("http:") === 0){
                url = url.substr("http://".length);
            }

            //detect parent window protocol and use that instead!!!
            url = [window.location.protocol, "//", url].join("");

            return url;
        }

        function loadContest() {
            if (!contestId || contestId.length !== 6) {
                throw new Error("Unable to bootstrap contest due to bad or missing contestid attribute!");
            }

            var styleTag = document.createElement("STYLE");
            var txt = document.createTextNode('.scrollDiv { overflow: auto; -webkit-overflow-scrolling:touch; }  .contestiFrame { width: 1px; min-width: 100% }');
            styleTag.appendChild(txt);
            document.head.appendChild(styleTag);

            scrollDiv = document.createElement("div");
            scrollDiv.className += " scrollDiv";

            contestSrc = setProperUrlProtocol(contestSrc);

            contestIframe = document.createElement("iframe");
            contestIframe.id = "contestiFrame";
            contestIframe.height = contestHeight;
            contestIframe.width = contestWidth;
            contestIframe.className += " contestiFrame";
            contestIframe.scrolling = "no";
            contestIframe.src = contestSrc.replace("////", "//"); //shim for no-protocol urls

            contestIframe.onload = function () {
                log("Contest iFrame onload()");

                // Begin Handshake
                // Send config
                var data = {};
                data.funcName = "hostReady";
                data.params = {};
                data.params.parentSrc = window.location.href;
                data.params.contestType = contestType;

                selfAddressed(mailman, contestIframe.contentWindow, data);
            };

            scrollDiv.appendChild(contestIframe);
            contestTag.appendChild(scrollDiv);
        }

        function setRemoteCookie(name, value, expires) {
            var data = {};
            data.funcName = "setCookie";
            data.params = {};
            data.params.name = name;
            data.params.value = value;
            data.params.expires = expires;

            selfAddressed(mailman, contestIframe.contentWindow, data);
        }

        function reloadContest() {
            var data = {};
            data.funcName = "reload";
            data.params = {};

            selfAddressed(mailman, contestIframe.contentWindow, data);
        }

        window.digitalIvy = window.digitalIvy || {};
        window.digitalIvy.hostLib = window.digitalIvy.hostLib || {};

        window.digitalIvy.hostLib.eventDefaults = {
            contestReady: function (envelope, params) {
                // First message from contest
                // Handshake Complete

                // Rewards: if logout we need to clear cookies here
                // Razor will redirect away from loginwidget to clear cookies
                if (sfott === "logout") {
                    var prevsfott = getCookie("sfott");
                    if (prevsfott) {
                        setCookie("tl_ugc", "", -1);
                        setCookie("ENT", "", -1);
                        setCookie("sfott", "", -1);
                        setRemoteCookie("tl_ugc", "", -1);
                        setRemoteCookie("ENT", "", -1);
                        setRemoteCookie("sfott", "", -1);
                        // Reload iframe
                        reloadContest();
                    }
                }
            },

            getCookie: function (envelope, params) {
                var value = getCookie(params.name);

                var data = {};
                data.funcName = "getCookie";
                data.params = {};
                data.params.value = value;

                selfAddressed(envelope, data);  // places the letter into the same envelope, allows response
                selfAddressed(mailman, contestIframe.contentWindow, envelope);
            },

            setCookie: function (envelope, params) {
                setCookie(params.name, params.value, params.expires);
            },

            resize: function (envelope, params) {
                var parentIframe = parent.document.getElementById('contestiFrame');

                if (parentIframe != null) {
                    if (params.iframeHeight != null && !isNaN(params.iframeHeight)) {
                        if (firstResizeFlag){
                            firstResizeFlag = false;
                            parentIframe.height = params.iframeHeight + 25;
                        } else {
                            parentIframe.height = params.iframeHeight;
                        }
                    }
                    if (params.iframeWidth != null && !isNaN(params.iframeWidth)) {
                        parentIframe.width = params.iframeWidth;
                    }
                }
            },

            getShareLink: function (envelope, params) {
                var data = {};
                data.funcName = "getShareLink";
                data.params = {};
                data.params.shareLink = window.location.href;

                selfAddressed(envelope, data);  // places the letter into the same envelope, allows response
                selfAddressed(mailman, contestIframe.contentWindow, envelope);
            },

            getQueryStringParameter: function (envelope, params) {
                var value = getQueryVariable(window.location, params.variable);

                var data = {};
                data.funcName = "getQueryStringParameter";
                data.params = {};
                data.params.variable = params.variable;
                data.params.value = value;

                selfAddressed(envelope, data);  // places the letter into the same envelope, allows response
                selfAddressed(mailman, contestIframe.contentWindow, envelope);
            }
        };

        // Make location object from url
        function getLocation(href) {
            var l = document.createElement("a");
            l.href = href;
            return l;
        }

        // Origin polyfill for IE/Edge
        function getOrigin(location) {
            if (!location.origin) {
                location.origin = location.protocol + "//"
                    + location.hostname
                    + (location.port && location.port != '80' && location.port != '443' ? ':' + location.port : '');
            }
            return location.origin;
        }

        function getCookie(name) {
            var value = null;
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) {
                    value = c.substring(nameEQ.length, c.length);
                }
            }
            return value;
        }

        function setCookie(name, value, exp) {
            var expires = "";
            if (exp) {
                var date = new Date(exp);
                expires = "; expires=" + date.toGMTString();
            }
            var domain = window.location.hostname.toLowerCase();
            if (domain !== "localhost") {
                domain = domain.split(".");
                domain = domain.slice(domain.length - 2).join(".");
                domain = "; domain=" + domain;
            } else {
                domain = "";
            }

            var cookie = name + "=" + value + expires + domain + "; path=/";

            if (window.location.protocol == "https:" && name.toLowerCase() !== "ent") {
                cookie = cookie + "; SameSite=None; Secure";
            }

            document.cookie = cookie;
        }

        function getQueryVariable(loc, variable) {
            var query = loc.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (window.decodeURIComponent(pair[0]) == variable) {
                    return window.decodeURIComponent(pair[1]);
                }
            }
        }

        function modifyUrl(originalUrl, addToUrl, arrAddToQString) {
            var urlSplit = originalUrl.split("?"),
                baseUrl = urlSplit[0],
                arrQString = [];

            if (urlSplit.length > 1) {
                arrQString = urlSplit[1].split("&");
            }

            if (arrAddToQString && arrAddToQString.length > 0) {
                arrQString = arrQString.concat(arrAddToQString);
            }

            if (addToUrl) {
                // add ending / if not there
                if (baseUrl.indexOf('/', baseUrl.length - 1) === -1) {
                    baseUrl = baseUrl + '/';
                }
                baseUrl = baseUrl + addToUrl;
            }

            if (arrQString && arrQString.length > 0) {
                baseUrl = [baseUrl, arrQString.join("&")].join("?");
            }

            return baseUrl;
        }

        function mailman(address, msg) {
            address.postMessage(msg, contestSrc);
        }

        function processSSOIntegrationMessageReceived(msg){
            if (!msg || !msg.msgID){
                return;
            }

            var handler = null;

            switch(msg.msgID){
                case "contestlib-sso-login":
                    handler = externalLoginEvent;
                    break;
                case "contestlib-sso-logout":
                    handler = externalLogoutEvent;
                    break;
                case "contestlib-sso-pop-see-modal":
                    _See.regUi.open('login');
                    break;
            }

            if (handler && handler.length > 0){
                var len = handler.length;
                for (var i=0; i<len; i++){
                    if (typeof(handler[i])==="function"){
                        handler[i](msg);
                    }
                }

            }
        }

        function receiveMessage(event) {
            var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.

            var hostLocation = getLocation(contestSrc);

            var hostOrigin = getOrigin(hostLocation);

            if (origin !== hostOrigin)
                return;

            var letter = selfAddressed(event.data);
            var envelope = event.data;

            if (letter) {
                if (letter.msgID){
                    log(letter.msgID);
                    processSSOIntegrationMessageReceived(letter);
                    return;
                }
                if (!letter.funcName){
                    return;
                }

                log(letter.funcName);

                var funcName = letter.funcName;
                var params = letter.params;

                if (funcName === "contestReady") {
                    if (window.digitalIvy && window.digitalIvy.hostLib && window.digitalIvy.hostLib.events &&(typeof window.digitalIvy.hostLib.events.contestReady === "function")) {
                        window.digitalIvy.hostLib.events.contestReady(envelope, params);
                    } else {
                        window.digitalIvy.hostLib.eventDefaults.contestReady(envelope, params);
                    }
                    //now tell contest if see has gigya enabled or not.
                    //don't bother if gigya is not enabled.
                    if (_See && _See.config && _See.config.rewards && _See.config.rewards.gigyaEnabled){
                        if (contestIframe && contestIframe.contentWindow){
                            selfAddressed(mailman, contestIframe.contentWindow, {msgID: "see-gigya-enabled", data: true});
                        }
                    }
                } else if (funcName === "getCookie") {
                    if (window.digitalIvy && window.digitalIvy.hostLib && window.digitalIvy.hostLib.events &&(typeof window.digitalIvy.hostLib.events.getCookie === "function")) {
                        window.digitalIvy.hostLib.events.getCookie(envelope, params);
                    } else {
                        window.digitalIvy.hostLib.eventDefaults.getCookie(envelope, params);
                    }
                } else if (funcName === "setCookie") {
                    // Set local cookie
                    if (window.digitalIvy && window.digitalIvy.hostLib && window.digitalIvy.hostLib.events &&(typeof window.digitalIvy.hostLib.events.setCookie === "function")) {
                        window.digitalIvy.hostLib.events.setCookie(envelope, params);
                    } else {
                        window.digitalIvy.hostLib.eventDefaults.setCookie(envelope, params);
                    }
                } else if (funcName === "resize") {
                    if (window.digitalIvy && window.digitalIvy.hostLib && window.digitalIvy.hostLib.events &&(typeof window.digitalIvy.hostLib.events.resize === "function")) {
                        window.digitalIvy.hostLib.events.resize(envelope, params);
                    } else {
                        window.digitalIvy.hostLib.eventDefaults.resize(envelope, params);
                    }
                } else if (funcName === "getShareLink") {
                    if (window.digitalIvy && window.digitalIvy.hostLib && window.digitalIvy.hostLib.events &&(typeof window.digitalIvy.hostLib.events.getShareLink === "function")) {
                        window.digitalIvy.hostLib.events.getShareLink(envelope, params);
                    } else {
                        window.digitalIvy.hostLib.eventDefaults.getShareLink(envelope, params);
                    }
                } else if (funcName === "getQueryStringParameter") {
                    if (window.digitalIvy && window.digitalIvy.hostLib && window.digitalIvy.hostLib.events &&(typeof window.digitalIvy.hostLib.events.getQueryStringParameter === "function")) {
                        window.digitalIvy.hostLib.events.getQueryStringParameter(envelope, params);
                    } else {
                        window.digitalIvy.hostLib.eventDefaults.getQueryStringParameter(envelope, params);
                    }
                }
            }
        }

        hostlib.addSSOEventListener = function(listener){
            if (!listener){
                return;
            }

            if (listener.login){
                externalLoginEvent.push(listener.login);
            }

            if (listener.logout){
                externalLogoutEvent.push(listener.logout);
            }
        };

        $(function(){
            var oldOnSeeReady = null;

            if (window._See){
                if (window.onSeeReady){
                    oldOnSeeReady = window.onSeeReady;
                }
                window.onSeeReady = function(){
                    if (_See && _See.config && _See.config.rewards && _See.config.rewards.gigyaEnabled){
                        if (_See.bindOrFireEvent){
                            _See.bindOrFireEvent("_See.Config.Ready", function(){
                                log("_See.Config.Ready fired.");
                                if (contestIframe && contestIframe.contentWindow){
                                    selfAddressed(mailman, contestIframe.contentWindow, {msgID: "see-gigya-enabled", data: true});
                                }                                
                            });
                            _See.bindOrFireEvent('RegApiReady', function() {
                                if (_See.ssoHandlers){
                                    if (_See.ssoHandlers.login){
                                        externalLoginEvent.push(_See.ssoHandlers.login);
                                    }
                                    if (_See.ssoHandlers.logout){
                                        externalLogoutEvent.push(_See.ssoHandlers.logout);
                                    }
                                }
                            });
                        }
                        if  (_See.bindEvent) {
                            _See.bindEvent('userLoggedIn', function () {
                                selfAddressed(mailman, contestIframe.contentWindow, {msgID: "hostlib-sso-login"});
                            });
                            _See.bindEvent('userLoggedOut', function () {
                                selfAddressed(mailman, contestIframe.contentWindow, {msgID: "hostlib-sso-logout"});
                            });
                        }
                    }
                    if (oldOnSeeReady && typeof(oldOnSeeReady) === "function"){
                        oldOnSeeReady();
                    }
                };
            }
        });

        window.addEventListener("message", receiveMessage, false);

    };

    document.addEventListener("DOMContentLoaded", function (e) { hostlib.injectContest(); });

    window.hostlib = hostlib;

}));


//////////////////
// WEBPACK FOOTER
// ./host/hostlib.js
// module id = 0
// module chunks = 0